import { DeprecatedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { LibraryShapeId } from '@core/constants/Shape';
import fieldPortfolioData from './common/fieldsPortfolioData';
import { IFormFieldKey, IForm } from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { additionalDataFactory } from './common/fieldsAdditionalData';
import { fieldsLibraryLargeDimension, fieldsLibraryMaterial } from './common/fieldsLibrary';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const libraryWithShelvesForm: IForm = {
    formId       : DeprecatedFormId.LibraryWithShelves,
    type         : FormTypeId.Library,
    thumbnailURL : '/resized-images/forms/libraryWithShelves.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.Material,
        IFormFieldKey.AddOns,
        IFormFieldKey.Background,
        IFormFieldKey.Dimension,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        material : fieldsLibraryMaterial,
        addOns   : {
            [LibraryShapeId.Shelf]: {
                value : undefined,
                min   : 0,
                max   : 20,
            },
        },
        background: {
            value: undefined,
        },
        dimension      : fieldsLibraryLargeDimension,
        additionalData : additionalDataFactory({
            budgetMin          : 1000,
            budgetMax          : 37000,
            budgetDefaultValue : 4500,
            marks              : budgetMarksBuilder(1000, 100, 8000, 500, 37000),
        }),
        contact: fieldsContact,
    },
};

export default libraryWithShelvesForm;
